import { SITE_NAME, SITE_ORIGIN } from '@wanderlust/shared';
import { SOCIAL_PROFILES } from './socialProfiles';

// Shared with the API, which builds the same canonical URLs when it renders
// article metadata at request time.
export { SITE_NAME, SITE_ORIGIN };
export const HOME_TITLE = 'Personalized Travel Planning | Wanderlust Cravings';
export const HOME_DESCRIPTION =
  "I'm Ken McGrady, a travel advisor. I help people work out where to go and where to stay, then I book it. You don't need a destination in mind to start.";
export const HOME_JSON_LD_ID = 'home-jsonld';

export function buildHomeJsonLd(origin: string = SITE_ORIGIN): string {
  return JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'TravelAgency',
    name: SITE_NAME,
    description: HOME_DESCRIPTION,
    url: `${origin}/`,
    image: `${origin}/logo.svg`,
    areaServed: 'Worldwide',
    sameAs: SOCIAL_PROFILES.map((profile) => profile.url),
    knowsAbout: [
      'Hotel and resort selection',
      'Celebration and anniversary travel',
      'Family vacation planning',
      'Group travel planning',
      'Culinary travel',
      'Nature-focused travel',
      'Flight and hotel booking',
    ],
  });
}
